import React, { FC } from "react";

import { ClientFilesTab } from "./ClientFilesTab";

/** The client page's "Files" tab (individuals and organizations). */
export const ClientFilesRoute: FC<{ customerId?: string | null }> = ({
  customerId,
}) => (customerId ? <ClientFilesTab customerId={customerId} /> : null);
